import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["acceptModal", "rejectModal", "data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Modal } from '@elements';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ErrorModal = function ErrorModal(_ref) {
  var acceptModal = _ref.acceptModal,
      rejectModal = _ref.rejectModal,
      data = _ref.data,
      props = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = data || {},
      name = _ref2.name,
      message = _ref2.message;

  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsx(Modal.Title, _objectSpread(_objectSpread({}, props), {}, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        fontWeight: 700,
        children: name
      })
    })), /*#__PURE__*/_jsx(Modal.Content, {
      children: /*#__PURE__*/_jsx(Box, {
        pb: 3,
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "body1",
          fontWeight: 400,
          children: message
        })
      })
    })]
  });
};